import React from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';
import Cookies from 'universal-cookie';

export function getAcceptedTerms(id) {
  const [acceptedTerms, setAcceptedTerms] = React.useState([]);
  React.useEffect(() => {
    (async function () {
      const cookies = new Cookies();
      var token = cookies.get('auth0_token', { path: '/' });
      
      const { data } = await axios.get(`${endpoints.core}/orders/${id}/accepted-terms`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { locale: window.freedomeConfig.locale }
      });
      setAcceptedTerms(data);
    })();
  }, []);
  
  return (
    acceptedTerms
  );
}
